package com.rainbowclubs.rainbow.domain.use_cases.events

import com.rainbowclubs.rainbow.data.models.Event
import com.rainbowclubs.rainbow.data.requests.UpdateEventAttendeeRequest
import com.rainbowclubs.rainbow.domain.repositories.EventsRepository

class UpdateEventAttendeeUseCase(
    private val eventsRepository: EventsRepository,
) {
    suspend operator fun invoke(request: UpdateEventAttendeeRequest): Result<Event> {
        return eventsRepository.updateEventAttendee(request)
    }
}
